import React from 'react';

const Approvisionnements = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Gestion des Approvisionnements</h1>
      <div className="bg-white rounded-lg shadow p-4">
        <p>Page de gestion des approvisionnements en cours de développement.</p>
      </div>
    </div>
  );
};

export default Approvisionnements; 